var $body,
    $menu,
    $toggleRecipeSection,
    $imageSlider,
    $imageSliderThumbnails,
    $checkItem,
    $video,
    $instagramSlider,
    $hamburger,
    $iFrame,
    $reviewSlider,
    $faqToggle;


$(document).ready(function ($) {

    console.log('%cLinku Novio', "font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body = $('body');
    $hamburger = $('.js-menu-toggle');
    $menu = $(".js-menu");
    $toggleRecipeSection = $('.js-open-recipe-section');

    $checkItem = $('.js-check-item');
    $video = $('.wp-block-video');
    $instagramSlider = $('.js-instagram-feed');
    $reviewSlider = $('.js-review-slider');
    $iFrame = $('.js-iframe');

    $faqToggle = $('.js-faq-toggle');

    $faqToggle.click(function() {
        openAndCloseDiv(this);
    });

    $video.each(function () {
        $(this).addClass('show-play');
    });

    $hamburger.on('click', function (e) {
        if ($hamburger.hasClass('is-open')) {
            $(this).removeClass('is-open');
            $menu.removeClass('is-open');
        } else {
            $(this).addClass('is-open');
            $menu.addClass('is-open');
        }
    });

    $video.on('click', function () {
        $(this).toggleClass('show-play')
    });

    $checkItem.on('click', function () {
        $(this).toggleClass('is-checked');
    });

    $toggleRecipeSection.on('click', function () {
        const $selectedSection = $(this);

        if ($selectedSection.hasClass('is-open')) {
            $selectedSection.siblings('.c-process-section__steps').slideUp(400, 'swing');
            $selectedSection.removeClass('is-open');
        } else {
            $selectedSection.siblings('.c-process-section__steps').slideDown(400, 'swing');
            $selectedSection.addClass('is-open');
        }
    });

    $iFrame.each(function (index, value) {
        $(this).iFrameResize([{
            autoResize: true,
            enablePublicMethods: true,
            sizeWidth: false,
            log: true,
            interval: 36,
            checkOrigin: false
        }])
    });

    $reviewSlider.each(function (index, value) {
        let reviewSlider = tns({
            container: value,
            mode: 'carousel',
            items: 1.5,
            mouseDrag: true,
            speed: 600,
            nav: false,
            gutter: 24,
            autoplayButtonOutput: false,
            controls: true,
            controlsText: ['<i class="fal fa-long-arrow-left"></i>', '<i class="fal fa-long-arrow-right"></i>'],
            controlsPosition: "bottom",
            autoplay: false,
            autoHeight: false,
            autoplayHoverPause: true,
            rewind: true,
            responsive: {
                768: {
                    items: 3
                }
            }
        });
    });


    $instagramSlider.each(function (index, value) {
        var heroSlider = tns({
            container: value,
            items: 4,
            mouseDrag: true,
            speed: 600,
            gutter: 24,
            controlsText: ['<i class="far fa-chevron-left"></i>', '<i class="far fa-chevron-right"></i>'],
            controls: true,
            autoplayButton: false,
            autoplay: true,
            nav: false,
            fixedWidth: 250,
            autoplayButtonOutput: false
        });
    });

    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
    } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
    } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
    } else if (userAgent.match(/edg/i)) {
        browserName = "edge";
    } else {
        browserName = "No browser detection";
    }

    $(document.body).addClass("browser-" + browserName);

});

$(window).load(function(){
    $imageSlider = $('.js-image-slider');
    $imageSliderThumbnails = $('.js-image-slider-thumbnails');

    $('.js-sliders').each(function (index, value) {
        var id = $(this).attr('data-id');
        var sliderId = '#js-slider-' + id;
        var thumbnailId = '#js-thumbnail-' + id;

        var imageSlider = tns({
            container: sliderId,
            controls: false,
            autoHeight: true,
            mouseDrag: true,
            nav: false,
            navAsThumbnails: true,
            navContainer: thumbnailId,
            loop: true,
            items: 1,
            speed: 600
        });

        var thumbnailSlider = tns({
            container: thumbnailId,
            mouseDrag: true,
            speed: 600,
            gutter: 8,
            controls: false,
            controlsContainer: imageSlider,
            nav: false,
            items: 5,
            responsive: {
                992: {
                    items: 6
                },
                1200: {
                    items: 7
                }
            }
        });

        imageSlider.events.on('indexChanged', function (evt) {
            const indexToGoTo = evt.index > imageSlider.getInfo().slideCount ? 0 : evt.index - 1;
            thumbnailSlider.goTo(indexToGoTo);
        });

        $(thumbnailId + ' .js-thumbnail').on('click', function (evt) {
            var index = $(this).attr('data-index');
            console.log(index);
            imageSlider.goTo(index);
        });
    });
})

function openAndCloseDiv(obj){

    var $allFaqItems = $('.js-faq-card'); //All the content in FAQ
    var $faqItem = $(obj).closest('.js-faq-card'); //The clicked item
    var $answer = $faqItem.find(".js-faq-card__answer-content");

    if ($faqItem.hasClass('is-open')) {

        //Set current 'status' to closed
        $allFaqItems.removeClass('is-open');

        //Show the answer
        $answer.slideUp(300, 'swing');
    } else {
        //Set current 'status' to open
        $allFaqItems.removeClass('is-open');
        $faqItem.addClass('is-open');

        //Close all questions, except the one clicked on
        $allFaqItems.find(".js-faq-card__answer-content").slideUp(300, 'swing');
        $answer.slideDown(300, 'swing');
    }
}

function isMobile() {
    return window.matchMedia("only screen and (max-width:" + 992 + "px)").matches;
}
